module.exports = __webpack_public_path__ + "static/media/illo_thinking.3ae40e77.png";